<template lang="pug">
b-modal#getRejectDetail(
  ref="getRejectDetail"
  :title="$t('ui.combine.get_reject_detail')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th.text-center(width="5%")
              span #
            th(width="5%")
              span(:title="$t('ui.id')") {{ $t('ui.id') }}
            th(width="12%")
              span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
            th.text-right(width="8%")
              span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
            th(width="17%")
              span(:title="$t('ui.sender_bank')") {{ $t('ui.sender_bank') }} 
            th(width="17%")
              span(:title="$t('ui.recipient_bank')") {{ $t('ui.recipient_bank') }}
            //- th(width="12%")
            //-   span(:title="$t('ui.sender_bank')") {{ $t('ui.short.sender_bank') }}
            //- th(width="15%")
            //-   span(:title="$t('ui.sender_bank_acc_no')") {{ $t('ui.short.sender_bank_acc_no') }}
            //- th(width="15%")
            //-   span(:title="$t('ui.sender_bank_acc_holder')") {{ $t('ui.short.sender_bank_acc_holder') }}
            //- th(width="15%")
            //-   span(:title="$t('ui.recipient_bank_id')") {{ $t('ui.short.recipient_bank_id') }}
            //- th(width="15%")
            //-   span(:title="$t('ui.recipient_bank_acc_no')") {{ $t('ui.short.recipient_bank_acc_no') }}
            //- th(width="15%")
            //-   span(:title="$t('ui.recipient_bank_acc_holder')") {{ $t('ui.short.recipient_bank_acc_holder') }}
            th.text-center(width="10%")
              span(:title="$t('ui.status')") {{ $t('ui.status') }}
            th.text-right(width="13%")
              span(:title="$t('ui.reject_date')") {{ $t('ui.short.reject_date') }}
            th.text-right(width="13%")
              span(:title="$t('ui.processing_date')") {{ $t('ui.short.processing_date') }}
        tbody
          tr(v-if="rejectList.length == 0")
            td(colspan="13").text-center
              span {{ $t('message.no_data_available') }}
          tr(v-for="(item, index) in rejectList")
            td.text-center
              span(:title="index + 1") {{ index + 1 }}
            td
              span(:title="item.id") {{ item.id }}
            td
              span(:title="item.member_id") {{ item.member_id }}
            td.text-right
              span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
            td
              span(:title="item.sender_bank_id") {{ item.sender_bank_id }}
              br
              span(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}
              br
              span(:title="item.sender_bank_acc_holder") {{ item.sender_bank_acc_holder }}
              br 
              span(:title="item.sender_payment_mode") {{ item.sender_payment_mode }}
            //- td
            //-   span(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}
            //- td
            //-   span(:title="item.sender_bank_acc_holder") {{ item.sender_bank_acc_holder }}
            td
              span(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}
              br
              span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
              br
              span(:title="item.recipient_bank_acc_holder") {{ item.recipient_bank_acc_holder }}
              template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                br
                span(:title="item.recipient_bank_acc_remark") {{ item.recipient_bank_acc_remark }}
              template(v-if="['AUD'].includes(getCurrencyCode)")
                br
                span(:title="item.recipient_bank_acc_remark_2") {{ item.recipient_bank_acc_remark_2 }}
            //- td
            //-   span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
            //- td
            //-   span(:title="item.recipient_bank_acc_holder") {{ item.recipient_bank_acc_holder }}
            td.text-center
              //- span(:title="item.status") {{ item.status }}
              span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
            td.text-right
              span(v-if="item.reject_date" :title="$moment(item.reject_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.reject_date).format('YYYY-MM-DD, HH:mm:ss') }}
            td.text-right
              span(v-if="item.processing_date" :title="$moment(item.processing_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.processing_date).format('YYYY-MM-DD, HH:mm:ss') }}
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: '',
      rejectList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  methods: {
    getRejectDetail: function() {
      let url = config.ticketWithdrawalRejectDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.item.rejected_ticket_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rejectList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.member_id;
      this.getRejectDetail();
    }
  }
};
</script>
